/** 平台 */
export enum PLATFORM {
  /** APP */
  APP = 'APP',
  /** H5 */
  H5 = 'H5',
  /** 小程序 */
  MINI = 'MINI',
}

/** 系统类型 */
export enum OS_TYPE {
  /** 苹果 */
  IOS = 'IOS',
  /** 安卓 */
  ANDROID = 'ANDROID',
  /** 鸿蒙 */
  HARMONY = 'HARMONY',
  /** 电脑 */
  PC = 'PC',
}
